import React,{useState,useEffect,useRef} from "react"
import { AxiosDeleteData, AxiosGetData, AxiosPostData, AxiosPutData } from "../../context/axiosfunction"
import { useGlobalContext } from "../../context/provider"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faDownload, faX } from "@fortawesome/free-solid-svg-icons"
import { faFloppyDisk, faTrashCan } from "@fortawesome/free-regular-svg-icons"
import { Segmented,Modal,message,Checkbox } from "antd"
import Link from "next/link"
import dayjs from "dayjs"

const NotiMobile = () => {

    const { theme, API, headers, privateKey, Noti_length, setNoti,DataUser } = useGlobalContext();
    const [Noti, setNotidata] = useState([]);
    const [open, setOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [page, setPage] = useState(1);
    const [onSelectSave,setOnSelectSave] = useState([])
    const [save,setSave] = useState(false)
    const [deletemodal,setDelete] = useState(false)
      const [notitype,setNotiType] = useState('feed')
      const [notitypedata,setnotitypedata] = useState([])
    const scrollContainerRef = useRef(null);
    const [messageAPI,contextHolder] = message.useMessage()
    const sentinelRef = useRef(null);

    const SaveClick = async(id)=>{
        await AxiosPostData(API,'/api/checkauthent/click_noti',{id},headers)
    }

    const OnLoadNoti = async () => {
        try {
            const GetNoti = await AxiosGetData(API, "/api/checkauthent/get_usernoti", headers, privateKey);
            setNotidata(GetNoti)
            // console.log(GetNoti);
            localStorage.setItem('Noti',0)
            setNoti(0)
            setSelectdata(GetNoti)
        }catch(error){

        }
    }

    

    useEffect(()=>{
        if(notitype==='feed'){
          const filterfeed = Noti.filter(data=> data.noti.type!=='SYSTEM')
          setnotitypedata(filterfeed)
        }else if(notitype==='system'){
          const filterSystem = Noti.filter(data=> data.noti.type==='SYSTEM')
          setnotitypedata(filterSystem)
        }else if(notitype==='keep'){
          const filterKeep = Noti.filter(data => data.archived===1)
          setnotitypedata(filterKeep)
        }
    
    },[Noti,notitype])
    
    const GetNoti = () => {
        
        if(open===false){
            OnLoadNoti()
        }
        setOpen(!open)
    }

    const OnDelete = async()=>{
        // console.log(DataUser.uid);
        
        try {
            const deletenoti =  await AxiosDeleteData(API,'checkauthent/delete_noti',DataUser.uid,headers)

            if(deletenoti.status==='success'){
                messageAPI.open({
                    type:'success',
                    content:'ลบแจ้งเตือนทั้งหมดแล้ว'
                })

                return setTimeout(()=>{
                    setNotidata((prev)=> 
                    prev.filter((x) => x.archived !== 1)
                    )
                },500)
            }
        } catch (error) {
            
        }
    }
    // console.log(Noti);
    
    
    const SaveNoti = async() => {
        const noti_id = {noti_id:onSelectSave}
        
        try {
        const response = await AxiosPutData(API,'/api/checkauthent/save_noti',noti_id,headers)
        if(response.status==='success'){
            setNotidata((prev) =>
            prev.map((item) =>
                onSelectSave.includes( item.id) 
                ? { ...item, archived: 1 } 
                : item
            )
            );
            setSave(false)
        }
        
        } catch (error) {
        
        }
    }

      const OnSelectSave = (id) => {
            setOnSelectSave((prev) => {
            if (prev.includes(id)) {
                return prev.filter((x) => x !== id);
            } else {
                return [...prev, id];
            }
            });
        };

  

    return(
        <div>
            {contextHolder}
            <Modal title="ลบแจ้งเตือน" open={deletemodal} onCancel={()=>setDelete(false)} onOk={OnDelete}>
                <div>ต้องการลบแจ้งเตือนทั้งหมดในไอดีใช่หรือไม่</div>
            </Modal>
            <>
            <button onClick={()=>GetNoti()} className="w-[35px] sm:w-[48px] cursor-pointer rounded-full page-surface h-[35px] sm:h-[48px] flex items-center justify-center relative" >
                {theme==='light_theme' ? 
                    <img className="w-auto sm:h-[24px] h-[19px]" src="https://eve-image.eveebook.com/image.eveebook/web_image/bell.png" alt="bell" /> :
                    <img className="w-auto sm:h-[24px] h-[19px]" src="https://eve-image.eveebook.com/image.eveebook/web_image/bell-w.png" alt="bell" />
                }
                <div className="absolute top-[-5px] sm:top-0 right-[-7px] sm:right-0">
                    {(Noti_length&&Noti_length) > 0 &&
                        <div className=" text-[10px] font-bold text-white flex justify-center items-center w-[17px] h-[17px] bg-[#E04C4C] rounded-full">
                            <span>{Noti_length}</span>
                        </div>
                    }
                </div>
            </button>
            </> 
            
            <div className={`absolute top-[60px] pb-3 right-0 h-[93vh] overflow-y-scroll w-[100vw] page-surface transition-transform duration-500 ease-in-out 
                ${open ? 'translate-x-0' : 'translate-x-full'}`}>
                    <div className="sticky top-0 z-10 flex justify-between items-center w-full h-[48px] px-4 page-surface border-b border-gray-200">
                        <Segmented 
                            className="page-surface noti-seg text-primary w-full rounded-none"
                            options={[{label:'แจ้งเตือน',value:'feed'},{label:'ฟีตข่าว',value:'system'},{label:'ที่จัดเก็บ',value:'keep'}]} 
                            onChange={(value)=>setNotiType(value)} 
                        />
                        <div className="flex gap-[1em]">
                            {save ? 
                                <button onClick={()=>SaveNoti()} className="cursor-pointer">
                                    <FontAwesomeIcon className="text-[rgb(8,131,28)]" icon={faFloppyDisk}/>
                                </button>
                                :
                                <button onClick={()=>setSave(true)} className="cursor-pointer">
                                <FontAwesomeIcon className="text-[rgb(8,131,28)]" icon={faDownload}/>
                                </button>
                            }
                            <button onClick={()=>setDelete(true)} className="cursor-pointer">
                                <FontAwesomeIcon icon={faTrashCan} />
                            </button>
                            <button onClick={()=>GetNoti()} className="cursor-pointer">
                                <FontAwesomeIcon icon={faX} />
                            </button>
                        </div>
                    </div>
                    {/* <div className=""></div> */}
                    {notitypedata.length>0 ? 
                    <>
                    {notitypedata.map((data,i)=>{
                        const parsed = (() => {
                            try {
                                return JSON.parse(data.noti.data || "{}");
                            } catch (e) {
                                return {};
                            }
                        })();
                        const link = parsed.link || "#";
                        const img = parsed.image || "";
                        if(save){
                            return (
                                <Checkbox style={{paddingLeft:'15px'}} key={i} onChange={()=>OnSelectSave(data.id)}>
                                    <div className="block text-primary px-3 min-h-[80px] hover:bg-gray-50">
                                        <div className="grid grid-cols-12 items-center py-2">
                                            <div className="col-span-2">
                                            {parsed.image && <img src={parsed.image} alt="img" className="w-full h-auto object-cover" />}
                                            </div>
                                            <div className="col-span-10 pl-2">
                                            <div className={`${!data.is_read && 'font-bold'} line-clamp-2`}>{data.noti.title}</div>
                                            <div className="text-[12px] mx-2 line-clamp-2">{data.noti.body}</div>
                                            <div className="text-[12px] mx-1 ">{dayjs(data.noti.delivered_at).format('D MMM YYYY HH:mm น.')}</div>
                                            
                                            </div>
                                        </div>
                                    </div>
                                </Checkbox>
                            );
                        }else{
                            return(
                                <Link href={link} key={i} onClick={()=>SaveClick(data.id)} passHref className="w-full px-3 min-h-[80px] flex  ">
                                    <div className="grid grid-cols-12 items-center py-2">
                                        <div className="col-span-2">
                                        {img ? <img src={img} alt="" className="w-full h-auto object-cover" /> : null}
                                        </div>
                                        <div className="col-span-10 pl-2">
                                        <div className={`${!data.is_read &&'font-bold'} line-clamp-2`}>{data.noti.title}</div>
                                        <div className="text-[12px] mx-2 line-clamp-2">{data.noti.body}</div>
                                            <div className="text-[12px] mx-1 ">{dayjs(data.noti.delivered_at).format('D MMM YYYY HH:mm น.')}</div>

                                        </div>
                                    </div>
                                </Link>
                            )
                        }
                        
                    }
                    )}
                    <div ref={sentinelRef} />
                    </>
                    :
                    <div className="flex flex-col items-center 1justify-center gap-[1em] my-5">
                        <img src="https://eve-image.eveebook.com/image.eveebook/mascot/shock.png" alt="nonnoti" />
                        <div className="text-primary">{(notitype==='feed'||notitype==='system') ? 'ไม่พบแจ้งเตือน' :'ไม่มีแจ้งเตือนที่บันทึกไว้'}</div>
                    </div>
                    }
                    
            </div>
        </div>
        
    )
}

export default NotiMobile